import {getSquadsJsonSuccess} from "modules/actions/squads";
import Api from "modules/utils/Api";
import {call, put} from "typed-redux-saga/macro";

export const fetchSquadsSaga = function* () {
	const squads = yield* call(Api.Jsons.squads);
	if (squads?.data.squads?.length) {
		yield* put(getSquadsJsonSuccess(squads.data.squads));
	}
};

export default fetchSquadsSaga;
